import React from 'react';
import {
  PredictionsContext,
  PredictionsContextProvider,
} from './contexts/PredictionsContext';

export function getContextModule({
  servicesManager,
  commandsManager,
  extensionManager,
}) {
  return [
    {
      name: 'PredictionsContext',
      context: PredictionsContext,
      provider: ({ children }) => {
        return (
          <PredictionsContextProvider
            servicesManager={servicesManager}
            commandsManager={commandsManager}
          >
            {children}
          </PredictionsContextProvider>
        );
      },
    },
  ];
}
